import { FiPlus, FiX } from "react-icons/fi"
import Button from "src/component/button/button"
import { useState } from "react"
import { useTemplateData } from "src/Context/TemplateData.context"
import HierarchyTopicModal from "./HierarchyTopicModal"
import HierarchyPathDisplay from "src/components/HierarchyPathDisplay"
import {
  hierarchyTopicKey,
} from "src/utils/hierarchyTopic"
import { HierarchyTopicSelection } from "src/types/hierarchyTopic"

type IGroupType = {
  index: number
}

const Group = ({ index }: IGroupType) => {
  const [isOpen, setIsOpen] = useState(false)
  const {
    topicGroup,
    setTopicGroup,
    selectedSubject,
    selectedSubjectMeta,
    setValidationError,
  } = useTemplateData()

  const levelLabels = selectedSubjectMeta?.level_labels

  const handleAddTopic = (selection: Omit<HierarchyTopicSelection, "questions">) => {
    setValidationError("")
    const key = hierarchyTopicKey(selection)

    setTopicGroup((prev) =>
      prev.map((element, idx) => {
        if (index !== idx) return element

        const exists = element.topics.some(
          (topic) => hierarchyTopicKey(topic) === key
        )
        if (exists) {
          return {
            ...element,
            topics: element.topics.filter(
              (topic) => hierarchyTopicKey(topic) !== key
            ),
          }
        }

        return {
          ...element,
          topics: [
            ...element.topics,
            {
              ...selection,
              questions: [
                {
                  complexity: "easy" as const,
                  number: 1,
                },
              ],
            },
          ],
        }
      })
    )
  }

  const handleRemoveTopic = (topic: HierarchyTopicSelection) => {
    const key = hierarchyTopicKey(topic)
    setTopicGroup((prev) =>
      prev.map((element, idx) => {
        if (index !== idx) return element
        return {
          ...element,
          topics: element.topics.filter(
            (item) => hierarchyTopicKey(item) !== key
          ),
        }
      })
    )
  }

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValidationError("")
    setTopicGroup((prev) =>
      prev.map((element, idx) =>
        index === idx ? { ...element, name: e.target.value } : element
      )
    )
  }

  return (
    <div className='group'>
      <form>
        <input
          type='text'
          className='group_input'
          placeholder='Group Name'
          onChange={handleNameChange}
          value={topicGroup[index].name}
        />

        <Button
          text='Add topic'
          icon={<FiPlus />}
          type={"secondary"}
          className='add_subject'
          onClick={() => setIsOpen(true)}
          disabled={!selectedSubject}
        />
      </form>

      {topicGroup[index].topics.length > 0 && (
        <div className='selected_topic'>
          {topicGroup[index].topics.map((item) => {
            const key = hierarchyTopicKey(item)
            return (
              <div className='single_selected_topic' key={key}>
                <HierarchyPathDisplay
                  topic={item}
                  levelLabels={levelLabels}
                  className="text-sm font-medium text-white px-2"
                />
                <div className='close' onClick={() => handleRemoveTopic(item)}>
                  <FiX />
                </div>
              </div>
            )
          })}
        </div>
      )}

      {selectedSubject && (
        <HierarchyTopicModal
          subjectId={selectedSubject}
          levelLabels={levelLabels}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          onConfirm={handleAddTopic}
        />
      )}
    </div>
  )
}

export default Group
